import { colors, screen } from 'components/styles/variables';
import { LinkSet } from 'types/Apis/SearchURL';
import eventLogger from 'lib/EventLogger';
import LinkBankClickEvent from 'lib/Tracking/Srp/LinkBlankClickEvent';

interface LinkBankProps {
  linkSet: LinkSet;
}

export default function LinkBank({ linkSet }: LinkBankProps): JSX.Element {
  const onLinkBankClick = (): void => {
    eventLogger.log(LinkBankClickEvent());
  };
  return (
    <div className="link-bank-container">
      <div className="link-bank-title">{linkSet?.title?.toUpperCase()}</div>
      <div className="links-container">
        {linkSet?.search_urls?.map((searchUrl, index) => (
          <div className="link-container" key={searchUrl.url}>
            <a className="link" href={searchUrl.url} tabIndex={index} onClick={onLinkBankClick}>
              {searchUrl.link_text}
            </a>
          </div>
        ))}
      </div>

      <style jsx>
        {`
          .link-bank-container {
            padding: 24px 0px;
            border-top: 1px solid ${colors.G2};
          }
          .link-bank-container:first-of-type {
            margin-top: 52px;
          }
          .link-bank-title {
            font-weight: 700;
            font-size: 20px;
            color: ${colors.BLACK};
            line-height: 26px;
            letter-spacing: 0.2px;
          }
          .links-container {
            display: flex;
            flex-wrap: wrap;
            margin-top: 24px;
            gap: 0 5px;
          }
          .link-container {
            width: 33%;
            margin-bottom: 12px;
          }
          .link {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.2px;
            color: ${colors.BLACK};
          }
          .link:hover {
            color: red;
          }

          @media (max-width: ${screen.mdMax}) {
            .link-bank-container {
              margin: 0 24px;
            }
            .link-container {
              width: 40%;
            }
          }
          @media (max-width: ${screen.xsMax}) {
            .link-bank-container {
              padding: 24px 0px;
              border-top: 1px solid ${colors.G2};
              margin: 0 16px;
            }
            .link-container {
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}
